import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="container-site py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-book-open-line text-lg"></i>
            </span>
            <span className="font-heading text-2xl text-primary-600">{siteInfo.name}</span>
          </Link>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            专业的漫画阅读平台，支持翻页模式、横屏阅读、夜间模式，让看漫画更顺手。
          </p>
        </div>

        <div>
          <h4 className="font-semibold text-foreground-950 mb-4">快速导航</h4>
          <ul className="space-y-2.5">
            <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">首页</Link></li>
            <li><Link to="/category" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">漫画分类</Link></li>
            <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-foreground-950 mb-4">漫画分类</h4>
          <ul className="space-y-2.5">
            {categories.filter((c) => c !== "全部").slice(0, 6).map((cat) => (
              <li key={cat}>
                <Link to={`/category?type=${encodeURIComponent(cat)}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {cat}漫画
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-foreground-950 mb-4">联系我们</h4>
          <ul className="space-y-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500"></i>
              <a href={`mailto:${siteInfo.email}`} className="hover:text-primary-600 transition-colors">{siteInfo.email}</a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-primary-500"></i>
              <span>{siteInfo.phone}</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
              <span>{siteInfo.address}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-site py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.name} 版权所有，让看漫画更顺手。
          </p>
          <p className="text-xs text-foreground-500">漫画翻页模式 · 横屏阅读 · 夜间模式 · 缓存下载</p>
        </div>
      </div>
    </footer>
  );
}